// PRIMARY EVALUATION REPORT ROUTE
// Route: /results
// Data source: v5 run_full_evaluation() output via sessionStorage
// Loads data from sessionStorage (set by AnalysisLoading.jsx right after an
// evaluation completes) and hands it to EvaluationReportView, which owns
// the actual presentation. The public /evaluation/:id route
// (EvaluationResultPage.jsx) uses the same EvaluationReportView but loads
// its data by fetching from the backend instead of sessionStorage.

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import EvaluationReportView from './EvaluationReportView';

const VisibilityReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const raw = sessionStorage.getItem('analysisResult');
    if (!raw) { navigate('/analyze', { replace: true }); return; }
    try {
      const parsed = JSON.parse(raw);
      const userInput = sessionStorage.getItem('userInput');
      if (userInput) parsed.userInput = JSON.parse(userInput);
      setData(parsed);
      setLoading(false);
    } catch (e) {
      console.error('Parse error:', e);
      navigate('/analyze', { replace: true });
    }
  }, [navigate]);

  if (loading || !data) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f6f4fd' }}>
        <Loader2 style={{ width: 32, height: 32, color: '#7c3aed' }} className="animate-spin" />
      </div>
    );
  }

  return <EvaluationReportView data={data} />;
};

export default VisibilityReport;
